import { Injectable } from "@angular/core";
@Injectable()
export class CacheService {
    private isCacheEnabled = {
        learnerSpaces: false, // userSpaces-resolver.service.ts
        teacherSpaces: false, // teacher-spaces-resolver.service.ts and also for teacher-class.service.ts where it refer to data of space and particular class excluding analytics data
        adminSpaces: false, // admin-spaces-resolver.service.ts
        teacherClassViewDetailsCache: false, // 
        pushXGrantCredentialsMap : false
    }
    // Set true to enable cache and false to disable cache
    public setCachingStatus(key, value = true) {
        this.isCacheEnabled[key] = value;
    }
    public getCachingStatus(key) {
        return this.isCacheEnabled[key];
    }
    // Set all caches value to false.
    public clearCache() {
        Object.keys(this.isCacheEnabled).forEach((key) => this.isCacheEnabled[key] = false)
    }
}
